import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ListItem } from 'src/app/models/core.model';
import { LegionellaVisitSubmission } from 'src/app/models/legionella.model';
import { AuthService } from 'src/app/services/auth.service';
import { HttpLegionellaService } from 'src/app/services/http-legionella.service';
import { HttpMmtService } from 'src/app/services/http-mmt.service';

@Component({
    selector: 'app-weedfree-form-legionella',
    templateUrl: './weedfree-form-legionella.component.html',
    styleUrls: ['./weedfree-form-legionella.component.scss']
})
export class WeedfreeFormLegionellaComponent implements OnInit {
    @ViewChild('f') form: NgForm;

    message?: string;
    success: boolean = true;

    companies: ListItem[] = [];
    machineTypes: ListItem[] = [];

    selectedCompanyId: number = 3;
    selectedMachineType: number = 1;

    lat: number = 0;
    lng: number = 0;
    today: Date = new Date();
    files: any[] = [];
    uploadProgress: number = 0;

    constructor(
        private router: Router,
        private httpMmt: HttpMmtService,
        private http: HttpLegionellaService,
        private auth: AuthService,
    ) { }

    ngOnInit() {

        this.httpMmt.getFormOptions().subscribe(
            {
                next: (response) => {
                    this.companies = response.companies;
                    this.machineTypes = response.machineTypes;
                }
            });

        this.getLocation();
        this.today.setHours(12, 0, 0, 0);
    }

    getLocation() {

        if (navigator.geolocation) {

            navigator.geolocation.getCurrentPosition((position) => {
                this.lat = position.coords.latitude;
                this.lng = position.coords.longitude;
            });

        }

    }

    onFileChanged(event: any) {
        this.files = event.target.files;
    }

    onSubmit(form: NgForm) {
        // toDataURL == png format
        window.scroll(0, 0);

        this.message = undefined;

        const testTime = new Date(
            form.value.visitDate.getFullYear(),
            form.value.visitDate.getMonth(),
            form.value.visitDate.getDate(),
            form.value.testTime.getHours(),
            form.value.testTime.getMinutes()
        ).getTime();

        const visit: LegionellaVisitSubmission = {
            company: this.selectedCompanyId,
            site: form.value.siteName,
            machine: form.value.machineName,
            machineType: this.selectedMachineType,
            testDate: testTime,
            interpretation: form.value.interpretation,
            batchNumber: form.value.batchNumber,
            comments: form.value.comments
        };

        this.http.addVisit(visit).subscribe(
            (response: number) => {

                if (this.files.length > 0) {
                    this.addVisitFiles(response);
                } else {
                    this.success = true;
                    this.message = "Visit added";
                }

            },
            (error) => {
                console.log(error);
                this.message = error.error;
                this.success = false;
            }
        );

    }

    addVisitFiles(id: number) {
        this.http.addVisitFiles(id, this.files).subscribe(
            (response) => {
                this.success = true;
                this.message = "Visit added and files uploaded";
            },
            (error) => {
                console.log(error);
                this.message = "Visit added, but an error occurred when uploading files: " + error.error;
                this.success = false;
            }
        )

    }

}
